/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zippy_Neat_Parakeet_LockInputs */

const fr_zippy_neat_parakeet_lock = /** @type {(inputs: Zippy_Neat_Parakeet_LockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editer programme`)
};

/**

* @param {Zippy_Neat_Parakeet_LockInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const zippy_neat_parakeet_lock = /** @type {((inputs?: Zippy_Neat_Parakeet_LockInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zippy_Neat_Parakeet_LockInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_zippy_neat_parakeet_lock(inputs)
});